import React, { useState } from "react";
import { AiOutlineEye } from "react-icons/ai";
import { FiDownload, FiMail } from "react-icons/fi";
import { HiOutlineDotsVertical } from "react-icons/hi";

import DropdownWrapper from "components/layout/DropdownWrapper";

import {
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownText,
  IconContainer,
} from "./styles";

type BillsMenuIconProps = {
  openModal: () => void;
  sendEmail: () => void;
  download: () => void;
  loading: boolean;
};

const BillsMenuIcon = ({
  openModal,
  sendEmail,
  download,
  loading,
}: BillsMenuIconProps): JSX.Element => {
  const [show, setShow] = useState(false);

  const toggleShow = (): void => {
    setShow((prevState) => !prevState);
  };

  return (
    <Container>
      <IconContainer onClick={toggleShow}>
        <HiOutlineDotsVertical />
      </IconContainer>
      {show && (
        <DropdownWrapper hideDropdown={toggleShow}>
          <DropdownMenu>
            <DropdownItem disabled={loading} onClick={openModal}>
              <AiOutlineEye />
              <DropdownText>Detalhe do boleto</DropdownText>
            </DropdownItem>
            <DropdownItem disabled={loading} onClick={sendEmail}>
              <FiMail />
              <DropdownText>Enviar 2ª via por email</DropdownText>
            </DropdownItem>
            <DropdownItem disabled={loading} onClick={download}>
              <FiDownload />
              <DropdownText>Baixar 2ª via</DropdownText>
            </DropdownItem>
          </DropdownMenu>
        </DropdownWrapper>
      )}
    </Container>
  );
};

export default BillsMenuIcon;
